//Types
import {IGoTribeRevampPersuasion} from '@stencil/hotels-srp-reducer/src/types';

//Styles
import * as S from './GoTribeTierDetailsUI.styles';

interface GoTribeTierDetailsUIProps {
  goTribeRevampPersuasion: IGoTribeRevampPersuasion;
  isVisible: boolean;
}
const GoTribeTierDetailsUI = ({goTribeRevampPersuasion, isVisible}: GoTribeTierDetailsUIProps) => {
  return (
    <S.TierBenefitsCardOuter $isVisible={isVisible}>
      <S.TierBenefitsCard $gradient={goTribeRevampPersuasion?.info?.popUpBgColourCode?.join(', ')}>
        <S.TierBenefitsHeader>{goTribeRevampPersuasion?.info?.ctaHeading}</S.TierBenefitsHeader>
        <S.TierBenefitsList>
          {goTribeRevampPersuasion.data.map((item, index) => (
            <S.TierBenefitsListItem key={index.toString()}>
              {!!item.iu && <S.IconImg src={item.iu} />}
              {!!item.pt && <S.TierBenefitsListItemDesc>{item.pt}</S.TierBenefitsListItemDesc>}
            </S.TierBenefitsListItem>
          ))}
        </S.TierBenefitsList>
      </S.TierBenefitsCard>
      <S.TipPositioning />
    </S.TierBenefitsCardOuter>
  );
};

export default GoTribeTierDetailsUI;
